import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LevelUp3Icon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("circle", {
    cx: "15",
    cy: "7",
    r: "4"
  }), /*#__PURE__*/_jsx("path", {
    d: "M15,13a8.07,8.07,0,0,0-8,6.92,1,1,0,0,0,1,1.15H22a1,1,0,0,0,1-1.15A8.07,8.07,0,0,0,15,13Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M8.21,10.25,5.71,7.7A1,1,0,0,0,5,7.4H5a1,1,0,0,0-.71.3L1.81,10.2a1,1,0,0,0,1.42,1.41L4,10.83V15a1,1,0,0,0,2,0V10.85l.79.8a1,1,0,0,0,.71.3,1,1,0,0,0,.71-1.7Z"
  })]
}), 'LevelUp3Icon');